import axios from "axios";
import jsPDF from "jspdf";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import Appreciation_Certificate from "../../../../src/assets/b2bImages/Appreciation_Certificate.png";
import dummyCollaborationCertificate from "../../../assets/DummyCollaborationCertificate.jpg";
import dummyMembershipCertificate from "../../../assets/DummyMembershipCertificate.png";
import Layout from "../../../components/Layouts/Layouts/Layout";
import Layout2 from "../../../components/Layouts/Layouts/Layout2";
import AccordianSection from "../../../components/basic/Accordion";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import { getURLbyEndPoint } from "../../../store/api";
import { getAuthUserlocal, storeAuthUserlocal } from "../../../store/services";
import { useAuth } from "../../../context/auth";


const MembershipServices = () => {
  const navigate = useNavigate();
  const [pdfUrl, setPdfUrl] = useState("");
  const [isHovered, setHovered] = useState(false);
  const [daysLeft, setDaysLeft] = useState(null);
  const membershipType = getAuthUserlocal()?.selectMembership;
  const [validUpto, setValidUpto] = useState(getAuthUserlocal()?.validUpTo);
  const [pdfBlob, setPdfBlob] = useState(null);

  const membershipCertificate = getAuthUserlocal().membershipCertificate;
  const appreciationCertificate = getAuthUserlocal().appreciationCertificate;
  //View Certificate modal-------------------------------
  // ---------------------------------------------------------
  // ----------------------------------------------------------
  const [showCertificateModal, setShowCertificateModal] = useState(false);
  const [showAppreciationModal, setShowAppreciationModal] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState("");
  const [appreciationPdfUrl, setAppreciationPdfUrl] = useState("");
  const [latestInvoiceUrl, setLatestInvoiceUrl] = useState("");
  const [isDownloadingInvoice, setIsDownloadingInvoice] = useState(false);

  // Function to open the modal and set certificate URL
  const openCertificateModal = (certificateUrl) => {
    setCertificateUrl(certificateUrl);
    setShowCertificateModal(true);
  };

  // Function to close the modal
  const closeCertificateModal = () => {
    setShowCertificateModal(false);
  };


  // Function to open the modal and set certificate URL
  const openAppreciationCertificateModal = (certificateUrl) => {
    setAppreciationPdfUrl(certificateUrl);
    setShowAppreciationModal(true);
  };

  // Function to close the modal
  const closeAppreciationCertificateModal = () => {
    setShowAppreciationModal(false);
  };

  //renew mebership
  const [show, setShow] = useState(false);
  const [auth] = useAuth();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const [showCollabRenewModal, setShowCollabRenewModal] = useState(false);
  const handleCollabRenewClose = () => setShowCollabRenewModal(false);
  const handleCollabRenewShow = () => setShowCollabRenewModal(true);
  const [isCollabRenewalRequested, setIsCollabRenewalRequested] = useState(getAuthUserlocal()?.isCollabRenewalRequested || false);
  const [isRequestingCollabRenewal, setIsRequestingCollabRenewal] = useState(false);

  const [proccedPaymentFlag, setProccedPaymentFlag] = useState(true);
  const [renewPaymentMethod, setRenewPaymentMethod] = useState("razorpay"); // "razorpay" or "balance"
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  // //memberhsip renewal form is here------------------------
  // ---------------------------------------------------------
  // ---------------------------------------------------------
  // Razorpay script loader
  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Handle Razorpay payment for membership renewal
  const handleRazorpayRenewal = async () => {
    if (!totalAmount || totalAmount === 0) {
      alert("Please Enter Amount.");
      return;
    }

    if (!termsAccepted) {
      alert("Please accept the Terms and Conditions to proceed.");
      return;
    }

    const baseFee = totalAmount * 0.02;
    const gstOnFee = baseFee * 0.18;
    const totalConvenienceFee = Math.round(baseFee + gstOnFee);
    const amountWithFee = parseInt(totalAmount) + totalConvenienceFee;

    setProccedPaymentFlag(false);

    // Check if renewal request already exists before opening payment gateway
    try {
      const userId = getAuthUserlocal()._id;
      await axios.get(
        getURLbyEndPoint("checkMembRenewalExists") + userId,
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
    } catch (checkError) {
      if (checkError.response && checkError.response.status === 409) {
        alert(checkError.response.data.message || "Renewal request already exists");
        setProccedPaymentFlag(true);
        return;
      }
    }

    const isLoaded = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );
    if (!isLoaded) {
      alert("Razorpay SDK failed to load. Are you online?");
      setProccedPaymentFlag(true);
      return;
    }

    try {
      const orderUrl = getURLbyEndPoint("createRazorpayOrder");
      const { data: orderResponse } = await axios.post(
        orderUrl,
        { amount: amountWithFee },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      if (!orderResponse.status) {
        alert(orderResponse.message || "Failed to create order");
        setProccedPaymentFlag(true);
        return;
      }

      const { data: order, key_id } = orderResponse;
      const user = getAuthUserlocal();

      const options = {
        key: key_id,
        amount: order.amount,
        currency: order.currency,
        name: "AECCI",
        description: `Membership Renewal - ${noOfYears} Year(s)`,
        order_id: order.id,
        handler: async function (response) {
          try {
            const userId = getAuthUserlocal()._id;
            const verifyUrl =
              getURLbyEndPoint("renewMembershipRazorpay") + userId;
            const verifyPayload = {
              razorpayPaymentId: response.razorpay_payment_id,
              razorpayOrderId: response.razorpay_order_id,
              razorpaySignature: response.razorpay_signature,
              amount: totalAmount,
              noOfYears: noOfYears,
            };
            const verifyRes = await axios.post(verifyUrl, verifyPayload, {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            });

            if (verifyRes.data.status) {
              alert(verifyRes.data.message);
              handleClose();
              navigate("/wallet");
            } else {
              alert(
                verifyRes.data.message || "Payment verification failed"
              );
            }
          } catch (error) {
            console.error(error);
            alert("Payment verification failed on server");
          }
        },
        prefill: {
          name: user.companyName,
          email: user.email,
          contact: user.phoneNo,
        },
        theme: {
          color: "#3399cc",
        },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      setProccedPaymentFlag(true);
    } catch (error) {
      console.error(error);
      if (error.response && error.response.status === 409) {
        alert(error.response.data.message);
      } else {
        alert("Error initiating payment");
      }
      setProccedPaymentFlag(true);
    }
  };

  const handleCollabRenewSubmit = async () => {
    setIsRequestingCollabRenewal(true);
    try {
      const userId = getAuthUserlocal()._id;
      const response = await axios.post(
        getURLbyEndPoint("requestCollabRenewal") + userId,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );
      if (response.data.status) {
        alert(response.data.message);
        setIsCollabRenewalRequested(true);
        const currentLocal = getAuthUserlocal();
        storeAuthUserlocal({ ...currentLocal, isCollabRenewalRequested: true });
        handleCollabRenewClose();
      } else {
        alert(response.data.message || "Failed to submit request.");
      }
    } catch (error) {
      console.error("Error requesting collaboration renewal", error);
      alert("Error requesting collaboration renewal");
    } finally {
      setIsRequestingCollabRenewal(false);
    }
  };

  // Handle balance-based membership renewal (existing flow)
  const handleMembRenew = async () => {
    const validationRulesProceedPayment = {
      totalAmount: {
        message: "Please Enter Amount.",
        isValid: () => totalAmount !== 0,
      },
    };

    for (const field in validationRulesProceedPayment) {
      const { message, isValid } = validationRulesProceedPayment[field];
      if (!isValid()) {
        alert(message);
        return;
      }
    }

    // Convert totalAmount to integer
    const integerAmount = parseInt(totalAmount, 10);

    //validation for low balance
    if (getAuthUserlocal().balance - totalAmount < 0) {
      alert("Low Balance!!!");
      return;
    }

    const apiFormData = new FormData();

    //making form
    apiFormData.append("noOfYears", noOfYears);
    apiFormData.append("amount", totalAmount);

    const userId = getAuthUserlocal()._id;

    try {
      setProccedPaymentFlag(false);

      const res = await axios.post(
        getURLbyEndPoint("renewMembership") + userId,
        apiFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status) {
        alert(res.data.message);
        handleClose();
      } else {
        alert("Something went Wrong!");
      }
    } catch (error) {
      if (error.response.status === 409) {
        alert(error.response.data.message);
      } else {
        alert("Server is not responding!!");
      }
      if (error.response) {
        console.error("Response error:", error.response.data);
        console.error("Status code:", error.response.status);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Request setup error:", error.message);
      }
    } finally {
      // Re-enable the button regardless of success or failure
      setProccedPaymentFlag(true);
    }
  };

  // caculating total fees

  const annualFees = {
    "Small Business (Associate)": 6000,
    "Start-Up": 6000,
    Corporate: 10000,
    "Corporate +": 20000,
    Overseas: 6000,
    "Non-Profit Organization": 5500,
  };

  const [noOfYears, setNoOfYears] = useState(1);
  const [totalAmount, setTotalAmount] = useState(
    annualFees[membershipType] * noOfYears
  );

  const handleRadioChange = (event) => {
    setNoOfYears(parseInt(event.target.value));
  };


  const handleGenApp = () => {
    const selectedMembership = "Collaboration";
    const imgSource = Appreciation_Certificate;
    const companyName = 'TEWODROS GETACHEW TULU & ASSOCIATES LAW OFFICE';
    const userName = 'MR. TEWODROS GETACHEW TULU';

    if (!imgSource) {
      console.error(`Invalid membership type: ${selectedMembership}`);
      alert("Invalid membership type");
      return;
    }

    const orientation = "landscape";
    const format = [500, 340.75];

    const pdf = new jsPDF({
      unit: "mm",
      format: format,
      orientation: orientation,
    });

    // Set background image
    const imgWidth = pdf.internal.pageSize.getWidth();
    const imgHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(imgSource, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.setTextColor("#5d3e35");
    const userFontSize = 60;
    pdf.setFontSize(userFontSize);
    pdf.setFont("Eczar", "bold");
    const text1 = `${userName}`;
    const textWidth1 = pdf.getTextWidth(text1);
    const documentWidth1 = pdf.internal.pageSize.getWidth();
    const centerX1 = (documentWidth1 - textWidth1) / 2;
    const textY1 = 132;
    pdf.text(centerX1, textY1, text1);


    pdf.setTextColor("#5d3e35");
    const companyFontSize = 40;
    pdf.setFontSize(companyFontSize);
    pdf.setFont("Eczar", "bold");
    const text = `${companyName}`;
    const textWidth = pdf.getTextWidth(text);
    const documentWidth = pdf.internal.pageSize.getWidth();
    const centerX = (documentWidth - textWidth) / 2;
    const textY = 155;
    pdf.text(centerX, textY, text);

    const validityFontSize = 30;
    pdf.setFontSize(validityFontSize);

    const validUpto = "28/10/2024";

    const validUptoTextWidth = pdf.getTextWidth(validUpto);
    const validUptoCenterX = 150 - validUptoTextWidth / 2;
    const validUptoY = 280;

    pdf.text(validUptoCenterX, validUptoY, validUpto);
    // Generate PDF as Blob
    const blobPdf = pdf.output("blob", { encoding: "raw" });

    // Store the blob in the state to show the "eye" button
    setPdfBlob(new Blob([blobPdf], { type: "application/pdf" }));
  };

  // Function to open the PDF in a new tab
  const handleViewPdf = () => {
    if (pdfBlob) {
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl); // Opens the PDF in a new tab
    }
  };

  // Update totalAmount when noOfYears changes
  useEffect(() => {
    setTotalAmount(annualFees[membershipType] * noOfYears);
  }, [noOfYears, membershipType]);

  useEffect(() => {
    setPdfUrl(membershipCertificate);
    setAppreciationPdfUrl(appreciationCertificate);

    if (validUpto) {
      try {
        const currentDate = new Date();
        const validUptoDate = new Date(validUpto.replace(/-/g, "/"));

        if (!isNaN(validUptoDate.getTime())) {
          const differenceInTime =
            validUptoDate.getTime() - currentDate.getTime();
          const differenceInDays = Math.ceil(
            differenceInTime / (1000 * 3600 * 24)
          );

          const displayDays = differenceInDays <= 0 ? 0 : differenceInDays;
          setDaysLeft(displayDays);
        } else {
          console.error("Invalid date format for validUpto:", validUpto);
        }
      } catch (error) {
        console.error("Error parsing date:", error);
      }
    } else {
      console.error("validUpto is undefined");
    }

    // Fetch latest user details (to reflect collaborator/membership renewals)
    const fetchLatestUserInfo = async () => {
      try {
        const userId = getAuthUserlocal()?._id;
        if (!userId) return;
        const res = await axios.get(getURLbyEndPoint("getpersonalinfo") + userId);
        if (res.data.status && res.data.data) {
          const freshData = res.data.data;
          if (freshData.membershipCertificate) {
            setPdfUrl(freshData.membershipCertificate);
          }
          if (freshData.validUpTo) {
            setValidUpto(freshData.validUpTo);
          }
          if (freshData.isCollabRenewalRequested !== undefined) {
            setIsCollabRenewalRequested(freshData.isCollabRenewalRequested);
          }
          const currentLocal = getAuthUserlocal();
          storeAuthUserlocal({
            ...currentLocal,
            membershipCertificate: freshData.membershipCertificate || currentLocal.membershipCertificate,
            validUpTo: freshData.validUpTo || currentLocal.validUpTo,
            memberShipNo: freshData.memberShipNo || currentLocal.memberShipNo,
            isCollabRenewalRequested: freshData.isCollabRenewalRequested !== undefined ? freshData.isCollabRenewalRequested : currentLocal.isCollabRenewalRequested,
          });
        }
      } catch (err) {
        console.error("Error fetching latest user details:", err);
      }
    };
    fetchLatestUserInfo();

    // Fetch latest invoice
    const fetchLatestInvoice = async () => {
      try {
        const userId = getAuthUserlocal()._id;
        const res = await axios.get(getURLbyEndPoint("getLatestMembInvoice") + userId, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        });
        if (res.data.status && res.data.receiptFile) {
          setLatestInvoiceUrl(res.data.receiptFile);
        }
      } catch (error) {
        // No invoice found or error
        console.error("Error fetching latest invoice", error);
      }
    };
    fetchLatestInvoice();
  }, [validUpto]);

  const handleDownloadInvoice = async () => {
    setIsDownloadingInvoice(true);
    try {
      const response = await fetch(latestInvoiceUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Membership_Invoice.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the invoice", error);
      window.open(latestInvoiceUrl, "_blank");
    } finally {
      setIsDownloadingInvoice(false);
    }
  };

  return (
    <>
      <Layout>
        <Layout2>
          <DashboardHeader />
          <h4 className="mt-3">
            {getAuthUserlocal().selectMembership !== "Digital User"
              ? getAuthUserlocal().selectMembership === "Collaboration"
                ? "Certificate of Collaboration"
                : getAuthUserlocal().selectMembership === "Arbitration"
                  ? "Certificate of Arbitration"
                  : "Certificate of Membership"
              : "Membership Services"}
          </h4>

          <hr className="mt-3 mb-1" />

          {membershipType === "Digital User" ? (
            <div className="d-flex flex-column dashboardBlock">
              <div className="d-flex flex-column mt-1 mb-4 ms-2 ">
                <h5 className="mb-2">AECCI Membership & its Benefits,</h5>
                <span>
                  "Discover a world of possibilities and maximize your potential
                  with our flexible range of membership options, tailored to
                  meet your unique needs and goals.
                </span>
              </div>
              <AccordianSection />
            </div>
          ) : (
            <div className="d-flex flex-column dashboardBlock ">
              <h4 className="text-center align-content-center my-4 text-success">
                Congratulations for attaining your {membershipType === "Collaboration" ? "collaboration" : membershipType === "Arbitration" ? "Arbitration" : "membership"} certificate! You
                are now the part of AECCI's Members Fraternity. Access your
                certificate by clicking the tab below.
              </h4>
              <div
                style={{ position: "relative", width: "100%", height: "auto" }}
              >
                <div
                  style={{
                    textAlign: "center",
                    position: "absolute",
                    zIndex: 1,
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  <span
                    className="fw-semibold fs-3 cursor-pointer"
                    style={{
                      color: isHovered ? "grey" : "white",
                      transition: "color 0.3s",
                    }}
                    onClick={() =>
                      openCertificateModal(
                        getAuthUserlocal().membershipCertificate
                      )
                    }
                    onMouseOver={() => setHovered(true)}
                    onMouseOut={() => setHovered(false)}
                  >
                    VIEW CERTIFICATE
                  </span>
                </div>
                <img
                  width="100%"
                  height="550"
                  src={
                    membershipType === "Collaboration"
                      ? dummyCollaborationCertificate
                      : dummyMembershipCertificate
                  }
                  alt=""
                  srcSet=""
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    objectFit: "cover",
                    objectPosition: "top",
                    filter: "brightness(70%)",
                    maxHeight: "550px", // Set a maximum height for the image
                    width: "100%", // Ensure the image takes the full width of its container
                  }}
                  className="desktop-image" // Add a class for desktop-specific styles
                />
              </div>
              {/* 
              //rendering Certificate modal here--------------------
              -------------------------------------------------------
              ------------------------------------------------------ */}
              <CertificateModal
                show={showCertificateModal}
                onHide={closeCertificateModal}
                certificate={certificateUrl}
                membershipType={membershipType}
              />

              {/* {appreciationCertificate && (
                <div className="mt-4">
                  <h4>Certificate Of Appreciation</h4>
                  <hr />
                  <div
                    style={{ position: "relative", width: "100%", height: "auto" }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        position: "absolute",
                        zIndex: 1,
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <span
                        className="fw-semibold fs-3 cursor-pointer"
                        style={{
                          color: isHovered ? "grey" : "white",
                          transition: "color 0.3s",
                        }}
                        onClick={() =>
                          openAppreciationCertificateModal(
                            getAuthUserlocal().appreciationCertificate
                          )
                        }
                        onMouseOver={() => setHovered(true)}
                        onMouseOut={() => setHovered(false)}
                      >
                        VIEW CERTIFICATE
                      </span>
                    </div>
                    <img
                      width="100%"
                      height="550"
                      src={Appreciation_Certificate}
                      alt=""
                      srcSet=""
                      style={{
                        position: "relative",
                        overflow: "hidden",
                        objectFit: "cover",
                        objectPosition: "top",
                        filter: "brightness(70%)",
                        maxHeight: "550px",
                        width: "100%",
                      }}
                      className="desktop-image"
                    />
                  </div>
                  <CertificateModal
                    show={showAppreciationModal}
                    onHide={closeAppreciationCertificateModal}
                    certificate={appreciationPdfUrl}
                    membershipType={membershipType}
                  />

                  <Button onClick={handleGenApp}>Generate Certificate</Button>

                  {pdfBlob && (
                    <Button variant="primary" onClick={handleViewPdf} className="ml-2">
                      👁️ View Certificate
                    </Button>
                  )}
                </div>
              )} */}

              {membershipType !== "Collaboration" && (
                <>
                  <h3 className="text-center align-content-center mt-4 mb-2 text-danger pulse">
                    ALERT..!
                  </h3>
                  <h5 className="text-center align-content-center mt-2 mb-4 text-danger">
                    Your Membership subscription is valid for {daysLeft} days.
                  </h5>
                  <div className="text-center align-content-center">
                    <button
                      className="bg-color p-2 px-4 rounded border-0 fw-semibold"
                      onClick={() => handleShow()}
                    >
                      RENEW YOUR MEMBERSHIP
                    </button>
                  </div>
                </>
              )}

              {membershipType === "Collaboration" && (
                <>
                  <h3 className="text-center align-content-center mt-4 mb-2 text-danger pulse">
                    ALERT..!
                  </h3>
                  <h5 className="text-center align-content-center mt-2 mb-4 text-danger">
                    Your Collaboration is valid for {daysLeft} days.
                  </h5>
                  <div className="text-center align-content-center">
                    <button
                      className="bg-color p-2 px-4 rounded border-0 fw-semibold"
                      onClick={() => handleCollabRenewShow()}
                      disabled={isCollabRenewalRequested}
                    >
                      {isCollabRenewalRequested ? "RENEWAL REQUESTED" : "RENEW YOUR COLLABORATION"}
                    </button>
                  </div>
                </>
              )}

              {latestInvoiceUrl && (
                <div className="text-center align-content-center mt-3">
                  <button
                    className="bg-color p-2 px-4 rounded border-0 fw-semibold"
                    onClick={handleDownloadInvoice}
                    disabled={isDownloadingInvoice}
                  >
                    {isDownloadingInvoice ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Downloading...
                      </>
                    ) : (
                      "DOWNLOAD LATEST INVOICE"
                    )}
                  </button>
                </div>
              )}

              <Modal
                show={show}
                onHide={handleClose}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                size="lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>Membership Renewal</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div>
                    <Card>
                      <Card.Header>
                        {" "}
                        <h5>For Renewal fill the below form</h5>
                      </Card.Header>
                      <Card.Body>
                        <div className="d-flex justify-content-between">
                          <div className="w-50">
                            <h6>
                              Type of Memb :
                              <span className="text-secondary">
                                {" "}
                                {getAuthUserlocal().selectMembership}
                              </span>
                            </h6>

                            <h6>
                              Memb NO. :
                              <span className="text-secondary">
                                {" "}
                                {getAuthUserlocal().memberShipNo}
                              </span>
                            </h6>
                          </div>
                          <div className="w-50">
                            <h6>
                              Amount :{" "}
                              <span className="text-success">
                                ₹ {totalAmount}/-
                              </span>
                            </h6>
                            <h6>
                              Company Name :
                              <span className="text-secondary">
                                {" "}
                                {getAuthUserlocal().companyName}
                              </span>
                            </h6>
                          </div>
                        </div>

                        <hr />

                        <div>
                          <h6>Package Selection :</h6>
                          <Form className="d-flex">
                            <div key="radio" className="mb-3">
                              <Form.Check
                                inline
                                label="1 Year"
                                name="group1"
                                type="radio"
                                value="1"
                                onChange={handleRadioChange}
                                checked={noOfYears === 1}
                              />
                            </div>
                            <div key="radio" className="mb-3">
                              <Form.Check
                                inline
                                label="2 Year"
                                name="group1"
                                type="radio"
                                value="2"
                                onChange={handleRadioChange}
                                checked={noOfYears === 2}
                              />
                            </div>
                            <div key="radio" className="mb-3">
                              <Form.Check
                                inline
                                label="3 Year"
                                name="group1"
                                type="radio"
                                value="3"
                                onChange={handleRadioChange}
                                checked={noOfYears === 3}
                              />
                            </div>
                            <div key="radio" className="mb-3">
                              <Form.Check
                                inline
                                label="5 Year"
                                name="group1"
                                type="radio"
                                value="5"
                                onChange={handleRadioChange}
                                checked={noOfYears === 5}
                              />
                            </div>
                          </Form>
                        </div>

                        <hr />

                        <div>
                          <h6>Payment Method :</h6>
                          <Form className="d-flex gap-3">
                            <Form.Check
                              inline
                              label="Pay Online (Razorpay)"
                              name="renewPaymentMethod"
                              type="radio"
                              id="razorpay-renew"
                              value="razorpay"
                              checked={renewPaymentMethod === "razorpay"}
                              onChange={(e) =>
                                setRenewPaymentMethod(e.target.value)
                              }
                            />
                            <Form.Check
                              inline
                              label={`Use Wallet Balance (₹${getAuthUserlocal().balance || 0})`}
                              name="renewPaymentMethod"
                              type="radio"
                              id="balance-renew"
                              value="balance"
                              checked={renewPaymentMethod === "balance"}
                              onChange={(e) =>
                                setRenewPaymentMethod(e.target.value)
                              }
                            />
                          </Form>
                        </div>

                        {renewPaymentMethod === "razorpay" && totalAmount > 0 && (
                          <div className="mt-3 p-3 bg-light rounded">
                            <div className="d-flex justify-content-between mb-2">
                              <span>Registration Fee:</span>
                              <span>₹{totalAmount}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                              <span>Convenience Fee (2%):</span>
                              <span>₹{Math.round(totalAmount * 0.02)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                              <span>GST on Fee (18%):</span>
                              <span>₹{Math.round(totalAmount * 0.02 * 0.18)}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between fw-bold">
                              <span>Total Payable:</span>
                              <span>
                                ₹
                                {parseInt(totalAmount) +
                                  Math.round(totalAmount * 0.02 * 1.18)}
                              </span>
                            </div>
                          </div>
                        )}


                        {renewPaymentMethod === "razorpay" && (
                          <div className="d-flex align-items-center mt-3">
                            <Form.Check
                              type="checkbox"
                              id="terms"
                              checked={termsAccepted}
                              onChange={(e) => setTermsAccepted(e.target.checked)}
                              className="mr-2"
                            />
                            <span className="mb-2 ms-2">
                              I agree to the{" "}
                              <span
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() => setShowTermsModal(true)}
                              >
                                Terms & Conditions
                              </span>{" "}
                              and payment gateway convenience fee
                            </span>
                          </div>
                        )}

                        {renewPaymentMethod === "balance" && (
                          <div className="mt-3">
                            {getAuthUserlocal().balance >= totalAmount ? (
                              <div className="alert alert-success mb-0">
                                <strong>Sufficient Balance!</strong> ₹{totalAmount} will be deducted from your wallet balance of ₹{getAuthUserlocal().balance}.
                              </div>
                            ) : (
                              <div className="alert alert-danger mb-0">
                                <strong>Insufficient Balance!</strong> Your wallet balance is ₹{getAuthUserlocal().balance || 0}. Required: ₹{totalAmount}. Please add funds to your wallet or use online payment.
                              </div>
                            )}
                          </div>
                        )}

                      </Card.Body>
                    </Card>
                  </div>
                </Modal.Body>
                <Modal.Footer className="text-center justify-content-center">
                  <Button
                    variant="success"
                    onClick={
                      renewPaymentMethod === "razorpay"
                        ? handleRazorpayRenewal
                        : handleMembRenew
                    }
                    disabled={
                      !proccedPaymentFlag ||
                      (renewPaymentMethod === "razorpay" && !termsAccepted) ||
                      (renewPaymentMethod === "balance" &&
                        getAuthUserlocal().balance < totalAmount)
                    }
                  >
                    {renewPaymentMethod === "razorpay"
                      ? "PAY NOW"
                      : "PROCEED PAYMENT"}
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                show={showCollabRenewModal}
                onHide={handleCollabRenewClose}
                aria-labelledby="collab-renew-modal"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>Renew Collaboration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="text-center">
                    <p>
                      Are you sure you want to send a renewal request for your Collaboration?
                    
                    </p>
                  </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                  <Button variant="secondary" onClick={handleCollabRenewClose} disabled={isRequestingCollabRenewal}>
                    Cancel
                  </Button>
                  <Button variant="success" onClick={handleCollabRenewSubmit} disabled={isRequestingCollabRenewal}>
                    {isRequestingCollabRenewal ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Sending...
                      </>
                    ) : (
                      "Send Request"
                    )}
                  </Button>
                </Modal.Footer>
              </Modal>
              <hr className="mt-4 mb-4" />
            </div>
          )}
        </Layout2>
      </Layout>

      <Modal
        show={showTermsModal}
        onHide={() => setShowTermsModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Terms and Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <h5 className="text-center">
              AECCI – Terms & Conditions (Payment Gateway & Convenience Fee)
            </h5>
            <h6 className="text-center">
              AECCI – Wallet & Online Payment Terms
            </h6>

            <h6 className="mt-3">1. Payment Methods</h6>
            <p>Members may add wallet balance through:</p>
            <ul>
              <li>Manual Bank Transfer (NEFT / RTGS / IMPS), or</li>
              <li>
                Online Payment Gateway (Razorpay or any authorized gateway)
              </li>
            </ul>

            <h6>2. Convenience Fee</h6>
            <ul>
              <li>
                Online payments are subject to a convenience / payment
                processing fee
              </li>
              <li>
                This fee represents charges levied by payment aggregators,
                banks and technology service providers
              </li>
              <li>
                The fee is clearly disclosed prior to payment confirmation
              </li>
            </ul>

            <h6>3. User Consent</h6>
            <ul>
              <li>
                By proceeding with online payment, the user expressly agrees
                to pay the applicable convenience fee
              </li>
              <li>Manual bank transfers do not attract any such fee</li>
            </ul>

            <h6>4. Non-Refundable</h6>
            <ul>
              <li>
                Convenience fees and payment gateway charges are
                non-refundable, even in cases of transaction failure where the
                gateway has processed the transaction
              </li>
            </ul>

            <h6>5. GST & Taxation</h6>
            <ul>
              <li>
                Convenience fees are subject to applicable GST as per
                prevailing law
              </li>
              <li>A tax invoice shall be generated wherever applicable</li>
            </ul>

            <h6>6. Wallet Usage</h6>
            <ul>
              <li>
                Wallet balance is usable only for AECCI-approved services
              </li>
              <li>
                Wallet balance is non-transferable and non-interest bearing
              </li>
            </ul>

            <h6>7. Transaction Proof</h6>
            <ul>
              <li>
                Users must retain transaction reference numbers / UTR for
                future correspondence
              </li>
            </ul>

            <h6>8. Right to Modify</h6>
            <ul>
              <li>
                AECCI reserves the right to revise convenience fees or payment
                terms with prior notice on the platform
              </li>
            </ul>

            <h6>9. Governing Law</h6>
            <ul>
              <li>These terms shall be governed by the laws of India</li>
              <li>Jurisdiction: Courts of Navi Mumbai, Maharashtra</li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTermsModal(false)}
          >
            Close
          </Button>
          <Button
            variant="primary"
            disabled={!totalAmount || totalAmount === 0}
            onClick={() => {
              setTermsAccepted(true);
              setShowTermsModal(false);
            }}
          >
            Agree
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MembershipServices;

export const CertificateModal = ({ show, onHide, certificate, membershipType }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{membershipType === "Collaboration" ? "Certificate Of Collaboration" : membershipType === "Arbitration" ? "Certificate Of Arbitration" : "Membership Certificate"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <iframe
            src={certificate}
            title="Membership Certificate"
            width="100%"
            height="700px"
            frameBorder="0"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
